import { useContext } from 'react';
import ErrorReporterContext, {
  type Reporter,
  reporter,
} from '~/contexts/ErrorReporterContext';

const useErrorReporter = (): Reporter => useContext(ErrorReporterContext);

export { reporter, Reporter };
export default useErrorReporter;
